import { Stack, SxProps, Typography } from "@mui/material";
import { flexCentered } from "theme/base/flex";

interface Props {
  absoluteTime?: number;
  children: React.ReactNode;
  absoluteEnd?: number;
  absoluteStart?: number;
  sx?: SxProps;
}

const UPDATE_INTERVAL_IN_MS = 250;

export default function TransitionPlayer_Content({
  absoluteTime,
  children,
  absoluteEnd,
  absoluteStart,
  sx,
}: Props) {
  return (
    <Stack
      sx={{
        position: "relative",
        width: "100%",
        height: "100%",
        backgroundColor: "rgb(0,0,0)",
        fontSize: "2.5vh",
        cursor: "pointer",
        overflow: "hidden",
        containerType: "inline-size",
        ...flexCentered,
        ...sx,
      }}
    >
      <Typography
        sx={{
          overflowWrap: "break-word",
          wordWrap: "break-word",
          wordBreak: "break-word",
          textAlign: "center",
          opacity:
            absoluteTime != undefined &&
            absoluteStart != undefined &&
            absoluteEnd != undefined
              ? absoluteTime >= absoluteStart + UPDATE_INTERVAL_IN_MS / 1000 &&
                absoluteTime <= absoluteEnd - UPDATE_INTERVAL_IN_MS / 1000
                ? 1
                : 0
              : 1,
          transition: `opacity ${UPDATE_INTERVAL_IN_MS}ms`,
          fontSize: "7cqw",
          color: "white !important",
        }}
      >
        {children}
      </Typography>
    </Stack>
  );
}
